import { StrictMode, lazy, Suspense } from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

const CustomDataCollectionPage = lazy(() => import('./pages/CustomDataCollectionPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const VoiceTalentPage = lazy(() => import('./pages/VoiceTalentPage'));
const TalentPortalPage = lazy(() => import('./pages/TalentPortalPage'));

const fallback = <div className="h-screen w-screen bg-black" />;

const app = (
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/custom-data-collection" element={
          <Suspense fallback={fallback}>
            <CustomDataCollectionPage />
          </Suspense>
        } />
        <Route path="/voice-talent" element={
          <Suspense fallback={fallback}>
            <VoiceTalentPage />
          </Suspense>
        } />
        <Route path="/voice-talent/portal" element={
          <Suspense fallback={fallback}>
            <TalentPortalPage />
          </Suspense>
        } />
        <Route path="/audio-company-india" element={
          <Suspense fallback={fallback}>
            <AboutPage />
          </Suspense>
        } />
        {/* Legacy redirect — old /about URL kept routing-friendly to avoid 404s
            for any external link that hasn't migrated yet. The Netlify redirect
            handles SEO-grade 301; this route is the SPA fallback. */}
        <Route path="/about" element={
          <Suspense fallback={fallback}>
            <AboutPage />
          </Suspense>
        } />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);

const root = document.getElementById('root')!;

// If pre-rendered HTML exists, hydrate (preserves DOM → fast LCP).
// Otherwise (e.g. during Puppeteer pre-rendering), create fresh.
if (root.childNodes.length > 0) {
  hydrateRoot(root, app, {
    onRecoverableError: () => {},   // Suppress benign framer-motion hydration mismatch warnings
  });
} else {
  createRoot(root).render(app);
}
